<script lang="ts">
    import { spaLink } from "../../actions"
    import { navigationCache } from "../../store"

    export let location: LocationStore = undefined

    let paths: string[] = []

    $: if (location?.path?.match(/\/[^\/]+\//)) {
        let _paths: string[] = []
        let _p = location.path
        while (_p || _p.includes("/")) {
            _paths.push(_p)
            // remove last part
            _p = _p.replace(/\/[^\/]+\/?$/, "")
        }
        paths = _paths.reverse()
    } else {
        paths = []
    }
</script>

<!-- only for paths with more levels -->
{#if paths.length}
    <nav aria-label="Breadcrumbs" class="breadcrumbs">
        <div class="container vp-m">
            <ol>
                {#each paths as path}
                    {#if $navigationCache[path]}
                        <li><a use:spaLink href="{path}">{$navigationCache[path].name}</a></li>
                    {/if}
                {/each}
            </ol>
        </div>
    </nav>
{/if}
